import { LAYOUT_DESKTOP_MIN_WIDTH_PX } from "../../const/const";

const PRECISE_PIN_NARROW_ANTICIPATE_S = 0.05;

export function anticipatePinForMobileSectionIndex(index: number): number {
  const formula = 0.36 - index * 0.022;
  if (window.innerWidth < LAYOUT_DESKTOP_MIN_WIDTH_PX) {
    return Math.max(0.08, Math.min(0.28, formula));
  }
  return Math.max(0.15, Math.min(0.4, formula));
}

export function anticipatePinForStackSection(
  pinPrecise: boolean,
  index: number,
): number {
  if (pinPrecise) {
    const narrow = window.innerWidth < LAYOUT_DESKTOP_MIN_WIDTH_PX;
    return narrow ? PRECISE_PIN_NARROW_ANTICIPATE_S : 0;
  }
  return anticipatePinForMobileSectionIndex(index);
}

export function pinEndScrollDistance(section: HTMLElement) {
  return () => {
    const rawVh =
      window.visualViewport?.height ?? window.innerHeight;
    const vh = Math.max(1, Math.round(rawVh));
    const h = Math.max(1, Math.round(section.offsetHeight));
    const delta = Math.max(1, Math.min(h, vh));
    return `+=${delta}`;
  };
}